export enum Field {
  Reason = 'reason',
  UserExplanation = 'userExplanation',
}

export type FormModel = {
  [Field.Reason]: number | string
  [Field.UserExplanation]: string
}
